import { formatDateTime, toDate } from "../../../core/lib/format";

/** « 15 mars 2026 » ; « — » sans date. */
export function formatDay(value: number | string | null | undefined): string {
  return formatDateTime(value, { dateStyle: "long" });
}

/** « 15 mars 2026 » compact pour les tableaux. */
export function formatDayShort(value: number | string | null | undefined): string {
  return formatDateTime(value, { dateStyle: "medium" });
}

/** Valeur d'un <input type="date"> (jour local), vide sans date. */
export function toDateInputValue(value: number | string | null | undefined): string {
  const d = toDate(value);
  if (!d) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
